<template>
  <div class="col-sm-12">
    <div class="ev-sponsor-list">
      <div v-if="slider.SHOW_TITLE" class="sponsor-title">{{ slider.NAME || slider.TITLE }}</div>
      <div :id="'slider-' + slider.uuid" class="ev-slider" :class="isPremium ? 'premium' : 'standard'">
        <VueSlickCarousel v-if="items.length" v-bind="settings">
          <div v-for="item in items" :key="'slider-' + item.uuid" class="sponsor-item-outer sponsor-tile">
            <div class="sponsor-item-inner">
              <template v-if="isPremium && !item.IS_L">
                <img :src="item.IMAGE" :alt="item.TITLE" />
              </template>
              <template v-else-if="isPremium && item.IS_L && item.IS_EX && !item.IFRAME_OK">
                <a :href="item.EXTERNAL_LINK" target="_blank">
                  <img :src="item.IMAGE" :alt="item.TITLE" />
                </a>
              </template>
              <template v-else>
                <modal-window-link
                  modal-window-name="iframe-modal-window"
                  :context="{
                    title: item.COMPANY_NAME || item.TITLE,
                    url:
                      options.type === 'spl'
                        ? item.URL + '?src=ar'
                        : item.IS_EX
                        ? item.EXTERNAL_LINK
                        : item.INTERNAL_LINK + '?src=ar'
                  }"
                >
                  <a
                    href="javascript:void(0)"
                    class="modal-opener"
                    :data-title="item.COMPANY_NAME || item.TITLE"
                    :data-url="
                      options.type === 'spl'
                        ? item.URL + '?src=ar'
                        : item.IS_EX
                        ? item.EXTERNAL_LINK
                        : item.INTERNAL_LINK + '?src=ar'
                    "
                  >
                    <img :src="item.COMPANY_LOGO || item.IMAGE" :alt="item.COMPANY_NAME || item.TITLE" />
                  </a>
                </modal-window-link>
              </template>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { fieldComparator } from "@/helpers/helpers";
import BaseMixin from "@/components/DigitalEvent/mixins/BaseMixin";

export default {
  name: "SponsorSliderSlick",
  components: { VueSlickCarousel },
  props: {
    slider: {
      type: Object,
      default: null
    },
    isPremium: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    },
    items: {
      type: Array,
      default: () => []
    },
    orderBy: {
      type: String,
      default: null
    }
  },
  mixins: [BaseMixin],
  data() {
    return {
      settings: {
        slidesPerRow: +this.slider.SLIDER_SLIDES_TO_SHOW || +this.slider.SLIDES_TO_SHOW,
        autoplaySpeed: this.slider.SLIDER_SPEED * 1000,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: false,
        dots: false,
        autoplay: this.slider.AUTO_PLAY
      }
    };
  },
  mounted() {
    // for sponsor sliders - orderBy could be manual list order or 'asc' which is on COMPANY_NAME
    if (this.orderBy) {
      if (this.orderBy === "asc") {
        this.items.sort(fieldComparator("COMPANY_NAME"));
      } else {
        this.items.sort(fieldComparator("LIST_ORDER"));
      }
    }
  }
};
</script>

<style>
.slick-slider,
.slick-slider * {
  height: 100%;
}
.slick-slider img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}
</style>
